import * as React from 'react';
import * as queryString from 'query-string';

import { followUpOnlyTitle, fullApplicationTitle, fullApplicationTitleAllProducts } from 'login-constants/titles';
import * as stateUtils from 'login-utils/stateUtils';
import * as featureFlags from 'login-utils/featureFlags';
import LeftPane, { LeftPaneProps } from '../../Common/PaneLayout/LeftPane/LeftPane';

export default class BorrowerActivationLeftPane extends React.Component<
  ReactRouter.RouteComponentProps<{}, {}> & LeftPaneProps
> {
  getFullApplicationTitle() {
    return featureFlags.isEnabled('activationScreenUpdatedCopy20200226')
      ? fullApplicationTitleAllProducts
      : fullApplicationTitle;
  }

  render() {
    const { location, ...leftPaneProps } = this.props;
    const queryParams = stateUtils.getOptionalCreationParams(queryString.parse(location.search), ['isFollowUpOnly']);
    const isFollowUpOnly = queryParams.isFollowUpOnly;
    const title = isFollowUpOnly ? followUpOnlyTitle : this.getFullApplicationTitle();

    return <LeftPane {...leftPaneProps} documentTitle="Activate" showBackButton={false} title={title} />;
  }
}
